import { useBjelinTranslations } from "../../hooks/TranslationHooks";
import { useNews } from "../../hooks/NewsHooks";
import Page from "../../layout/Page";
import NotFoundPage from "../NotFoundPage";
import NewsGrid from "../../components/NewsGrid";
import Herobox from "../../components/Herobox";
import { useEffect } from "react";
import { useNavigationContext } from "../../functional-components/NavigationContext";
import { newsBaseUrl } from "../../config/urls";
import "./style.scss";

const NewsListPage = () => {
  const news = useNews(100);
  const t = useBjelinTranslations();
  const { registerCurrentPaths } = useNavigationContext();

  useEffect(() => {
    registerCurrentPaths({
      all: newsBaseUrl
    });
  }, [registerCurrentPaths]);

  if (!news || !news.length) {
    return <NotFoundPage />;
  }

  return (
    <Page
      name="news-list-page"
      key="news-list-page"
      title={t("news.list.page")}
    >
      <Herobox type="slim" textShadow={true} className={"text-center"}>
        <h1>{t("news.list.page")}</h1>
      </Herobox>

      <div className="news-list-container">
        <NewsGrid news={news} />
      </div>
    </Page>
  );
};

export default NewsListPage;
